(function() {
    'use strict';
    
a3_cabin_reports.factory('MedicalIncidentFactory',  MedicalIncidentFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name MedicalIncidentFactory
    * @description 
    *   Manage Report's MedicalIncindents.
    * @ngInject
    */
function MedicalIncidentFactory(GenericModalFactory) {

        /**
        * @memberof CabinReports
        * @ngdoc factory
        * @name MedicalIncidentFactory
        * @description 
        *   Manage Report's MedicalIncindents.
        * @ngInject
        */
		function MedicalIncident() {
			this.Id = null;
			this.FAKUsed = null;
			this.Medicine = null;
			this.Symptoms = null;
			this.Signature = null;
			this.Name = null;
			this.Phone = null;
			this.Email = null;
			this.DoctorInvolved = null;
			this.DoctorName = null;
			this.DoctorPhone = null;
            this.EMFAKUsed = null;
		}
	
		var service = {
			createNew : createNew,
			fromObject : fromObject,
			fromObjectList : fromObjectList,
			deleteFromList : deleteFromList
		}
		
        /**
         * Create a new MedicalIncident object 
         * @memberof MedicalIncidentFactory
         * @returns {object} MedicalIncident
         */	
		function createNew() {
			return GenericModalFactory.createNew(MedicalIncident)
		}

        /**
         * Create a new MedicalIncident object 
         * @memberof MedicalIncidentFactory
         * @returns {object} MedicalIncident
         */	
		function fromObject(obj) {
			return GenericModalFactory.fromObject(obj,MedicalIncident)
		}

        /**
         * Delete MedicalIncident object from given list
         * @memberof MedicalIncidentFactory
         * @param {object} obj The MedicalIncident object that will be deleted
         * @returns {array} MedicalIncindents
         */
		function deleteFromList(obj, objList) {
			return GenericModalFactory.deleteFromList(obj, objList)
		}
    
        /**
         * Extend given MedicalIncident object List 
         * @memberof MedicalIncidentFactory
         * @param {object} obj The MedicalIncident object that will be extended
         * @returns {array} MedicalIncindents
         */  
		function fromObjectList(objList) {
			return GenericModalFactory.fromObjectList(objList,MedicalIncident)
		}

		return service;
	}

})();